/**
 * This class name is used to label all html elements that should not appear in screenshots or reports
 * presented to the user. These may include buttons that users can interact with, but that make no sense
 * in a static screenshot.
 */
export const HIDE_FROM_SCREENSHOTS_CLASS = "hide-from-screenshots";
